import { yupResolver } from "@hookform/resolvers/yup";
import type React from "react";
import { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { DealEditorFooter } from "~/components/common/deals/new/DealEditorFooter";
import type { DealParam } from "~/models/DealForm";
import {
	buildDealParam,
	validationSchemaV2 as validationSchema
} from "~/models/DealForm";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { useDealQueryParams } from "~/pages/deals/new";
import { DealEditorBodyV2 } from "./DealEditorBodyV2";

export const DealEditor: React.FC = () => {
	const { company } = useContext(ItandiAccountContext);
	const { leasingId, dealType } = useDealQueryParams();

	const methods = useForm<DealParam>({
		defaultValues: buildDealParam({
			dealType,
			inspectionBy: company?.defaultInspectionBy ?? "vendor",
			leasingId
		}),
		mode: "onBlur",
		resolver: yupResolver(validationSchema),
		shouldFocusError: false
	});
	return (
		<div>
			<FormProvider {...methods}>
				<DealEditorBodyV2 />
				<DealEditorFooter />
			</FormProvider>
		</div>
	);
};
